<template>
  <v-row no-gutters class="button-tile-row">
    <v-col cols="12">
      <v-row class="info-tiles-row">
        <v-col
          class="info-tile-segment"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          v-for="(tile, index) in tiles"
          :key="index"
        >
          <InfoTile
            :imageUrl="tile.imageUrl"
            :title="tile.title"
            :description="tile.description"
          ></InfoTile>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import InfoTile from "./InfoTile.vue";

export default {
  name: "ButtonTiles",
  components: {
    InfoTile,
  },
  props: {
    tiles: {
      required: true,
      default: [],
      type: Array,
    },
  },
};
</script>

<style scoped lang="scss">
.info-tiles-row {
  display: flex;
  justify-content: center;
  margin: 0;
  .col {
    padding: 0;
  }

  .info-tile-segment {
    display: flex;
    padding-left: 31px;
    padding-right: 31px;
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
